import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";



export const Logout = () => {


    Cookies.remove('token');
    window.location.href ="/"
    

    return <></>
}